export enum ComponentName {
  Header = 'header',
  Footer = 'footer',
  Tab = 'tab'
}
